import React, { useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { CheckoutForm } from 'pages/Payment/CheckoutForm';

const Payment = () => {
  const promise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

  useEffect(() => {
    document.title = 'Pagamento - Revisão FGTS - LOIT';
  }, []);

  return (
    <>
      <Elements stripe={promise}>
        <CheckoutForm />
      </Elements>
    </>
  );
};

export default Payment;
